<!--
  --
  -- 日付入力カード
  --
  -->
<template>
  <v-card class="c-date-picker-card">
    <v-date-picker
      v-model="date"
      locale="ja"
      full-width flat
      color="primary"
      :day-format="dayFormat"
      :allowed-dates="allowedDates"
    />

    <v-card-actions>
      <v-spacer/>

      <v-btn
        text
        @click="onCancel"
      >
        <span>キャンセル</span>
      </v-btn>

      <v-btn
        text color="primary"
        @click="onOK"
        :disabled="!date"
      >
        <span>OK</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss">
.c-date-picker-card {
  .v-picker__body {
    background: transparent !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
}
</style>

<script>
import * as time from '@/libs/time'

export default {
  name: 'CDatePickerCard',

  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    /**
     * 選択値 yyyy-mm-dd
     */
    value: {
      type: String,
      required: true
    },

    /**
     * 日付が選択可能かを判定する関数
     */
    allowedDates: {
      type: Function,
      default: (value) => true
    }
  },

  data: () => ({
    date: ''
  }),

  created () {
    this.date = this.value
  },

  methods: {
    /**
     * カレンダーの日にちフォーマット
     */
    dayFormat (value) {
      return time.create(value).getDate()
    },

    /**
     * キャンセル ボタン
     */
    onCancel () {
      this.date = this.value
      this.$emit('close')
    },

    /**
     * OK ボタン
     */
    onOK () {
      this.$emit('change', this.date)
      this.$emit('close')
    }
  }
}
</script>
